import requester from '@/lib/axios';
import { OrderingField } from '@/models/Filter';
import JsonApiResponse from '@/models/JsonApiResponse';
import { KlassStatusEnum } from '@/models/Klass';
import ScheduledLessonExam, {
  ExamSchedulingStatusEnum,
} from '@/models/ScheduledLessonExam';
import { BaseFilters } from '@/models/Service';

export type ScheduledLessonExamOrdering = OrderingField<'datetime'>;

export interface ScheduledLessonExamFilters extends BaseFilters {
  klassId?: number;
  klassStatus?: KlassStatusEnum[];
  status?: ExamSchedulingStatusEnum;
  isActive?: boolean;
  dateRangeAfter?: string;
  dateRangeBefore?: string;
  ordering?: ScheduledLessonExamOrdering;
}

const baseUrl = 'scheduled-lesson-exams';

export async function listScheduledLessonExams(
  params: ScheduledLessonExamFilters = {},
) {
  const { data } = await requester().get<JsonApiResponse<ScheduledLessonExam>>(
    `${baseUrl}/`,
    {
      params,
    },
  );
  return data;
}
